import { MbtAddGate } from "./MbtAddGate";

const usd = (v) => (v == null ? "—" : `${v < 0 ? "-" : "+"}$${Math.abs(v).toFixed(2)}`);
const r = (v) => (v == null ? "—" : `${v > 0 ? "+" : ""}${v.toFixed(2)}R`);

const Cell = ({ label, value, sub, color, testid }) => (
  <div className="min-w-[64px]" data-testid={testid}>
    <div className="text-[6.5px] uppercase tracking-[0.16em] text-[var(--r2-text2)]">{label}</div>
    <div className="r2-num text-[9.5px] font-bold leading-tight" style={{ color: color || "var(--r2-text1)" }}>{value}</div>
    {sub && <div className="text-[7px] text-[var(--r2-text2)]">{sub}</div>}
  </div>
);

export const MbtLivePosition = ({ lp, slip }) => {
  if (!lp) return null;
  const dirC = lp.direction === "LONG" ? "var(--r2-emerald)" : "var(--r2-red)";
  const slipC = lp.slippage_ticks == null ? undefined : lp.slippage_ticks > 0 ? "var(--r2-amber)" : "var(--r2-emerald)";
  return (
    <div className="rounded-sm border border-[var(--r2-border)] bg-black/20 px-2 py-1" data-testid="mbt2-live-position">
      <div className="mb-1 flex items-center gap-2">
        <span className="text-[7px] font-bold tracking-[0.18em] text-[var(--r2-text2)]">LIVE POSITION</span>
        <span className="font-bold" style={{ color: dirC }} data-testid="mbt2-lp-side">{lp.direction} {lp.qty}x @ {lp.entry}</span>
        <span className="text-[var(--r2-text2)]">{lp.age_min}m · {lp.agent_managed ? "agent" : "manual"} · stop {lp.current_stop ?? "—"}</span>
        <span className="ml-auto r2-num font-bold" style={{ color: (lp.unrealized_usd ?? 0) >= 0 ? "var(--r2-emerald)" : "var(--r2-red)" }} data-testid="mbt2-lp-unrealized">{usd(lp.unrealized_usd)}</span>
      </div>
      <div className="flex flex-wrap gap-x-4 gap-y-1">
        <Cell label="MFE" value={usd(lp.mfe_usd)} sub={`${lp.mfe_pts.toFixed(1)} pts · ${r(lp.mfe_r)}`} color="var(--r2-emerald)" testid="mbt2-lp-mfe" />
        <Cell label="MAE" value={usd(lp.mae_usd)} sub={`${lp.mae_pts.toFixed(1)} pts · ${r(lp.mae_r)}`} color="var(--r2-red)" testid="mbt2-lp-mae" />
        <Cell label="Fees realised" value={`$${(lp.fees_usd ?? 0).toFixed(2)}`} sub={`$${(lp.fees_rt_usd ?? 0).toFixed(2)} round-trip`} testid="mbt2-lp-fees" />
        <Cell label="Slippage" value={lp.slippage_ticks == null ? "n/a" : `${lp.slippage_ticks > 0 ? "+" : ""}${lp.slippage_ticks}t`}
          sub={lp.slippage_ticks == null ? "no signal price" : `${usd(-(lp.slippage_usd ?? 0))} · signal ${lp.signal_price}`} color={slipC} testid="mbt2-lp-slippage" />
        <Cell label="Slip avg" value={slip?.avg_ticks == null ? "—" : `${slip.avg_ticks}t`} sub={`${slip?.n ?? 0} fills · ${slip?.source}`} testid="mbt2-lp-slip-avg" />
      </div>
      <MbtAddGate g={lp.add_gate} />
    </div>
  );
};
